import { useRecoilValue } from "recoil"
import { keyframes, styled } from "styled-components"
import { langText } from "../../lang-text/langText"
import { langSelector, langState } from "../../state/langState"
import { T4_ko } from "../../style/constant"
import { T4_en } from "../../style/constant"
import { B3 } from "../../style/constant"


const BlockChain = () => {
  const currentLang = useRecoilValue(langState)
  const Text = useRecoilValue(langSelector)

  return(
    <Container>
      <Wrapper>
        <TextArea currentLang = {currentLang}>
          <Title currentLang = {currentLang}>{Text.blockChain.title}</Title>
          <Desc currentLang = {currentLang}>{Text.blockChain.desc}</Desc>
        </TextArea>
      </Wrapper>
    </Container>
  )
}


export default BlockChain

type Props = {
  currentLang : boolean
}

const Container = styled.section`
  background: #060C17 url(/imgs/home/background/blockChain.jpg) no-repeat center center/contain;
  height:612px;
`

const moving = keyframes`
  0%{
    background:url(/imgs/home/blockChain.png) no-repeat -100% 0px/735px 100%;
  }
  100%{
    background:url(/imgs/home/blockChain.png) no-repeat left center/contain;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  width:1320px;
  height:100%;
  margin:0 auto;
  background:url(/imgs/home/blockChain.png) no-repeat left center/contain;

  animation:${moving} 1.5s ease;
  animation-fill-mode: forwards;
`

const TextArea = styled.div<Props>`
  ${props => props.currentLang ? 
  `

  `:
  `

  `
  }
`

const Title = styled.p<Props>`
  white-space: pre-line;
  ${props => props.currentLang ? 
  `
    ${T4_ko};
    margin:0 0 25px 0;
  `:
  `
    ${T4_en};
    margin: 0 0 14px 0;
  `
  }
`

const Desc = styled.p<Props>`
  white-space: pre-line;
  ${props => props.currentLang ? 
  `
    ${B3};
  `:
  `
    ${B3};
  `
  }
`